<div>
    <div class="modal-header">
        <h4 class="modal-title">Resultado de validación</h4>
        <button type="button" class="btn-close" mat-dialog-close></button>
    </div>
    <h5>Advertencias:</h5> 
    <div class="mat-elevation-z8 table-responsive">
        <table mat-table [dataSource]="dataSource" matSort class="w-100">

            <ng-container matColumnDef="sucursal">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Sucursales </th>
                <td mat-cell *matCellDef="let row"> {{row.sucursal}} </td>
            </ng-container>

            <ng-container matColumnDef="atributo">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Atributo </th>
                <td mat-cell *matCellDef="let row"> {{getAttribute(row)}} </td>
            </ng-container>

            <ng-container matColumnDef="valor">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Valor </th>
                <td mat-cell *matCellDef="let row"> {{getValue(row)}} </td>
            </ng-container>

            <ng-container matColumnDef="mensaje">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Mensaje </th>
                <td mat-cell *matCellDef="let row"> {{getValidation(row)}} </td>
            </ng-container>
            
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

        </table>
        <mat-paginator #pagi table-direc (paginatorLoaded)="dataSource.paginator=$event" [pageSizeOptions]="[10, 25, 100]"></mat-paginator>
    </div>
    <div *ngIf="uploadWarnings.length == 0" >
        No hay advertencias
    </div>
</div>